import React from "react";
import { connect } from "react-redux";
import disableBrowserBackButton from "disable-browser-back-navigation";
import { Alert } from "react-bootstrap";

import { Link, useMatch, useNavigate } from "../utils/components/router";
import CustomerAddressForm from "../Customer/CustomerAddressForm";
import { kundenActions, kundenAdresseActions } from "../actions";
import { RAGE_RIGHT } from "../utils/enums/RAGE_RIGHT";
import PageHeader from "./PageHeader";
import CONFIG from "../config";
import { isAuthenticated, scrollToTop } from "../utils/functions";
import { CloseIcon } from "../utils/components/icons";
import KundeLogin from "./KundeLogin";

class KundenAddresseMA extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.deleteAddress = this.deleteAddress.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }
  state = {
    kundenaddreses: [],
    loading: false,
    loaded: false,
    authenticated: false
  };

  get kundenId() {
    return String(this.props.params.id).match(/^[0-9a-z]+$/i)
      ? this.props.params.id
      : this.props.kundenStorage.getKundenId() || "";
  }

  componentDidMount = async () => {
    disableBrowserBackButton();
    this.setState({ authenticated: isAuthenticated(this.props) });
    // if (!this.props.mandantStorage.abwAdresseBsErlaubt()) {
    //   this.props.navigate(this.props.configStorage.getLinkPath("LINK_KUNDEN_ORDER_DETAILS_MA"));
    // }
  };

  componentDidUpdate() {
    scrollToTop();    
    if (
      this.state.authenticated &&
      !this.state.loading &&
      !this.state.loaded &&
      !this.state.kundenaddreses.length
    ) {
      this.fetchAdresse();
    }
  }

  fetchAdresse = async () => {
    if (this.state.loading) return;
    this.setState({ loading: true });
    let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde");
    requestDataKundenEntry.url = requestDataKundenEntry.url + this.kundenId;
    await this.props.dispatch(kundenActions.fetchEntry(requestDataKundenEntry));
    const kunde = this.props.kundenStorage.getKunde() || {};
    let kundeAdressen = kunde.listKundenAdressen || [];
    await this.props.dispatch(kundenAdresseActions.setAdressList(kundeAdressen));
    this.setState({ kundenaddreses: kundeAdressen, loading: false, loaded: true });
  };

  onSubmit = async formValues => {
    const id = Math.floor(Math.random() * 1000);
    formValues = { ...formValues, id };


    let kundeAdressen = this.props.kundenAdressenStorage.kundeAdressen;
    let data = {};
    if (!kundeAdressen) {
      data = { listKundenAdressen: [formValues] };
    } else {
      data = { listKundenAdressen: [...kundeAdressen, formValues] };
    }
    let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde", "post", data);
    requestDataKundenEntry.url = requestDataKundenEntry.url + this.kundenId + "/adresse";
    await this.props.dispatch(kundenAdresseActions.sendAdresse(requestDataKundenEntry));
    this.fetchAdresse();
  };

  deleteAddress = async id => {
    let adresseListe = this.props.kundenAdressenStorage.kundeAdressen;
    if (!Array.isArray(adresseListe)) adresseListe = [];
    adresseListe = adresseListe.filter(x => x.id !== id);
    let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde", "post", { listKundenAdressen: adresseListe });
    requestDataKundenEntry.url = requestDataKundenEntry.url + this.kundenId + "/adresse";
    await this.props.dispatch(kundenAdresseActions.sendAdresse(requestDataKundenEntry));
    this.fetchAdresse();
  };

  renderAdmin(address, idx) {    
    return (
      <div className="bootstrap-iso">
        <div className="container bg-white pt-one pb-one">
          <div className="row">
            <div className="col-12 float-end">
              <Link
                to={this.props.configStorage.getLinkPath("LINK_KUNDEN_ORDER_DETAILS_MA", address.id)}
                className="btn btn-primary edit col-6 col-sm-12"
              >
                Auswählen
              </Link>
              {(idx || (!this.props.configStorage.isVerseNeo() && !this.props.configStorage.isDeuBa()))
                ? <>                  
                  <Link
                    to={this.props.configStorage.getLinkPath("LINK_KUNDEN_ADDRESSE_MA_EDIT", this.kundenId) + `?x=${address.id}`}
                    className="btn btn-primary edit col-6 col-sm-12"
                  >
                    Bearbeiten
                  </Link>
                  <button
                    className="btn btn-danger col-6 col-sm-12"
                    data-bs-toggle="modal"
                    data-bs-target="#flipFlop"
                    onClick={() => {
                      this.setState({ id: address.id, name: address.name });
                    }}
                  >
                    Löschen
                  </button>
                  <div
                    className="modal fade"
                    id="flipFlop"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="modalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h4 className="modal-title" id="modalLabel">
                            {this.state.name}
                          </h4>
                          <button
                            type="button"
                            className="btn btn-default ser-close-modal"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            <CloseIcon></CloseIcon>
                          </button>
                        </div>
                        <div className="modal-body">
                          Sind Sie sicher, dass Sie diese Addresse löschen möchten?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-danger"
                            data-bs-dismiss="modal"
                            onClick={() => this.deleteAddress(this.state.id)}
                          >
                            Löschen
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            Abbrechen
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
                : null
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderList() {
    if (!Array.isArray(this.props.kundenAdressenStorage.kundeAdressen)) {
      return null;
    }
    let kunde = this.props.kundenStorage.getKunde();
    if (!kunde) {
      return <div className="row">
        <Alert className="col-12" variant="error">Es sind keine Kundendaten vorhanden</Alert>
        <div className="col-md-2">
          <Link
            onClick={this.cleanupModal}
            to={this.props.configStorage.getBackToShopLink()}
            className="btn btn-info col-12"
          >
            Zurück zum Shop
          </Link>
        </div>
      </div>;
    }
    return this.props.kundenAdressenStorage.kundeAdressen.map((address, idx) => {
      const adresseName = kunde.vorname ? kunde.vorname + " " + kunde.nachname : kunde.nachname;
      const ariaLabel = [
        adresseName,
        [address.strasse || "", address.strasse2 || ""].join(" "),
        [address.plz || "", address.ort || ""].join(" ")
      ].join(", ")
      return (
        <div
          className="bootstrap-iso"
          key={address.id}
        >
          <div className="row">
            <section className="col-12 col-sm-8 mb-one" aria-label={ariaLabel}>              
                {adresseName}              
              <div className="">
                {address.name
                  ? (
                    <div>
                      {address.name}{" "}
                    </div>
                  )
                  : null
                }
                {address.strasse
                  ? (
                    <div>
                      {address.strasse}{" "}
                    </div>
                  )
                  : <span>Klicken Sie auf "Bearbeiten", um eine Adresse hinzuzufügen</span>
                }
                {address.strasse2
                  ? (
                    <div>
                      {address.strasse2}{" "}
                    </div>
                  )
                  : null
                }
                {address.plz || address.ort
                  ? (
                    <div>
                      {address.plz} {address.ort}{" "}
                    </div>
                  )
                  : null
                }
              </div>
            </section>
            <div className="col-12 col-sm-4">{this.renderAdmin(address, idx)}</div>
          </div>
        </div>
      );
    });
  }

  isAuthenticated() {
    this.setState({ authenticated: true });
  }

  render() {
    if (!this.state.authenticated && !isAuthenticated(this.props)) {
      return (<KundeLogin authenticated={this.isAuthenticated}></KundeLogin>);
    }
    const kunde = this.props.kundenStorage.getKunde();
    if (!kunde) {
      return <div className="bootstrap-iso">
        <div className="row">
          <Alert className="col-12" variant="error">Es sind keine Kundendaten vorhanden</Alert>
          <div className="col-md-2">
            <Link
              onClick={this.cleanupModal}
              to={this.props.configStorage.getBackToShopLink()}
              className="btn btn-info col-12"
            >
              Zurück zum Shop
            </Link>
          </div>
        </div>
      </div>;
    }
    return (
      <div id={CONFIG.SHOP_ID} className="if6_outer section if6_section full-height">
        <PageHeader showTimeout={true} />
        <section className="bootstrap-iso" aria-label="Lieferadressen">
          <div className="container bg-white pt-one">
            <div className="row">
              <section className="col-12 col-md-5 col-lg-5" aria-label="auswählen">
                <div className="col align-self-center">
                  <h2 className="text-h2-secondary">
                    Lieferadresse auswählen
                  </h2>

                  <div className="">{this.renderList()}</div>
                </div>
              </section>
            {(this.props.mandantStorage.abwAdresseBsErlaubt() && !this.props.configStorage.isDeuBa()) ? (
              <section className="col align-self-start xol-12 col-md-7 col-lg-7 {mandant-storage.isBsAd" aria-label="hinzufügen">
                <div className="">
                  <div className="container">
                    <h2 className="text-h2-secondary">
                      Neue Lieferadresse hinzufügen
                    </h2>
                    <div className="col align-self-center">
                      <CustomerAddressForm
                        kundenVorname={kunde.vorname ? kunde.vorname : ""}
                        kundenNachname={kunde.nachname}
                        onSubmit={this.onSubmit}
                      />
                    </div>
                  </div>
                </div>
              </section>)
             : ""}
             </div>
            <hr />
            <div className="buttons row ms-0 mt-0 me-0 mb-two ps-0 gap-1" id="bottom-nav_Kunde">
              <Link
                to={this.props.configStorage.getBackToShopLink()}
                className="btn btn-info col-12 col-md-4 col-lg-2"
              >
                Zurück zum Shop
              </Link>
              <div className="col-0 col-md-1 col-lg-1"></div>
              {this.props.configStorage.kundeIsSelectable() && this.props.configStorage.isMaShop()
                ? <Link
                  to={this.props.configStorage.getLinkPath("LINK_MITARBEITER_ADD_KUNDEN")}
                  className="btn btn-default col-12 col-md-4 col-lg-2"
                >
                  Zurück zu Kundendaten
                </Link>
                : null
              }
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default connect(store => {
  return {
    configStorage: store.configStorage,
    kundenStorage: store.kundenStorage,
    kundenAdressenStorage: store.kundenAdresseStorage,
    rightStorage: store.rightStorage,
    authenticationStorage: store.authenticationStorage,
    mandantStorage: store.mandantStorage,
    requiredRageRight: [RAGE_RIGHT.RAGE_BERATER_EINS, RAGE_RIGHT.RAGE_BERATER_ZWEI]
  };
})((props) => {
  const { params } = useMatch();
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <KundenAddresseMA params={params} navigate={contextNavigate} {...props} />;
});
